import { createVNode as o, mergeProps as d } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/SearchSquareFilledStandard.js";
import i from "../components/PfIcon.js";
const r = (e, a) => {
  const t = {
    ...e,
    ...a.attrs
  };
  return o(i, d(t, {
    icon: l
  }), null);
};
r.displayName = "SearchSquareFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
